import Carac from './Carac.js'

export default class Resultat {

    id=''
    type='TASK'   //ou DIAL ?
    from=''
    x=0
    y=100
    data={
        reload:0,
        label:"Sortie",
        color:'#AAAAAA',
        condition:[],
        consequence:[],
        meta:[]
        }


    constructor(from,first) {
        this.from=from
        this.id="R"+Date.now()+1

        if(!first)
            this.data.color="#"+((1<<24)*Math.random()|0).toString(16)

    }


}